import React from 'react';
import Image from "next/legacy/image";

const EvilNoundleThumbnail = ({ tokenId, size, footer }) => {
  const src = `${process.env.NEXT_PUBLIC_EVIL_NOUNDLES_THUMBNAIL_BASEURL}${tokenId}.png`;
  const url = `https://opensea.io/assets/ethereum/0xbae654774c5f5a486805bad57d49c271b2c57814/${tokenId}`;

  return (
    <div>
      <a href={url}>
      <Image
        src={src}
        alt={`Ruggle #${tokenId}`}
        width={size}
        height={size}
        unoptimized
      />
      </a>
      {footer ? (
          <div>
            <div className="p-1 text-center fw-bold">Ruggle #{tokenId}</div>
          </div>
      ) : (
        <div>
        </div>
      )}
    </div>
  );
};

EvilNoundleThumbnail.defaultProps = {
  size: 200,
  footer: true,
};

export default EvilNoundleThumbnail;
